var resizeObservers = [];
export { resizeObservers };
